module.exports = __webpack_public_path__ + "static/media/code.30947c16.svg";